'use strict';

// account for just the CTAs on 'landing/dynamic-offer-detail', for now
// /central/landing/dynamic-offer-detail?offerid=highlander_lease_70623
define('lib/tda/saatchi',[
  'jquery',
  'lib/tda/kac',
  'dealerLiveChat',
  'features/ctas/index',
  'lib/getParameterByName',
  'lib/util/tda.config',
], function (
  $,
  kac,
  dealerLiveChat,
  ctas,
  paramByName,
  tdaConfig
) {
  var __dynOfferDetail = window.location.href.indexOf('/landing/dynamic-offer-detail') > -1;
  var __offerId = paramByName('offerid');
  var __providerId = tdaConfig.chat.provider_id;

  function offerDetailCtas() {
    var $scope = $('#sa-container #offer-detail'); // comes from their HTMLCode component
    var $clickToChatCta = $("a[data-destination='live-chat']", $scope);
    ctas.raq(__offerId, $scope); // wont do a thing, since they removed data-destination
    // ctas.dealerSite($scope); // they do their own thing with these

    // we don't yet have this as a feature/cta
    if ($clickToChatCta.length && __providerId) {
      if (tdaConfig.tda.code === 'KAC10') {
        $clickToChatCta.addClass('etsChatButton');
        $clickToChatCta.attr('data-destination', 'live-chat-kac');
        kac.dealerChat();
      } else {
        dealerLiveChat.init(__providerId);
      }
    }
  }

  if (__dynOfferDetail) {
    $(document).ready(function () {
      offerDetailCtas();
    });
  }
});

